import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const discountApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    discountListings: builder.mutation({
      query: ({ body }) => ({
        url: `${END_POINTS.discountListing}`,
        method: "POST",
        body,
      }),
    }),

    deleteDiscount: builder.mutation({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteDiscount}${id}/`,
        method: "DELETE",
      }),
    }),

    addDiscount: builder.mutation({
      query: ( body ) => ({
        url: `${END_POINTS.addDiscount}`,
        method: "POST",
        body,
      }),
    }),

    updateDiscount: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateDiscount}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    getDiscountById: builder.query({
      query: ({ id }) => ({
        url: `${END_POINTS.discountByid}${id}/`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useDiscountListingsMutation,
  useAddDiscountMutation,
  useDeleteDiscountMutation,
  useLazyGetDiscountByIdQuery,
  useUpdateDiscountMutation,
} = discountApi;
